import { AbstractControl, ValidationErrors } from '@angular/forms';
import { parse, isValid } from 'date-fns';

export function dateFormatValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const value = control.value;

  if (!value) return null;

  if (value.includes('_') || value.length < 10) {
    return { pattern: { text: value } };
  }

  const parsed = parse(value, 'MM/dd/yyyy', new Date());

  if (!isValid(parsed)) {
    return { pattern: { text: value } };
  }

  return null;
}
